export const IMPORT_SOURCE_META = 'doop-import-source'

/** The page a website import was captured from, read from the meta tag the
 *  importer stamps into the snapshot; undefined for any other frame. The
 *  value is encoded so an arbitrary query string cannot break the attribute. */
export function importedPageSource(html: string): string | undefined {
  const encoded = html.match(
    new RegExp(`<meta\\s+name=["']${IMPORT_SOURCE_META}["']\\s+content=["']([^"']+)["']`, 'i'),
  )?.[1]
  if (!encoded) return undefined
  try {
    return decodeURIComponent(encoded)
  } catch {
    return undefined
  }
}
